import { TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Divider, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { formattedStartToEndDuration } from '../../../contact-details/utils';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfilePositionItemProps as Props } from './types';

export const ProfilePositionItem = memo(
  ({ className, position, isLast }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ProfilePositionItem', className)}
        sx={SX.root}
        gap={0.5}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1}
        >
          <Typography variant="body4" color="grey.500" fontWeight={400}>
            {position?.employment_type || 'Not Specified'}
          </Typography>
          {position?.date?.start && (
            <Typography variant="body4" color="grey.500" fontWeight={400}>
              {formattedStartToEndDuration(
                position.date.start,
                position.date?.end
              )}
            </Typography>
          )}
        </Stack>
        <TextEllipsis variant="body4" color="grey.700" fontWeight={700}>
          {position?.title}
        </TextEllipsis>

        {!isLast && <Divider />}
      </Styled.Wrapper>
    );
  }
);

ProfilePositionItem.displayName = 'ProfilePositionItem';
